import React, { useRef, useState } from "react";
import { request } from "../../../functions/request";
import { Button, Checkbox, Descriptions, Form, Input, Select, Tooltip } from "antd";
import {
  updateData,
  formatDateHourToBR,
  verificarVariacaoValor,
} from "../../../functions/functionsUtility";
import { FaSave } from "react-icons/fa";

const trigoOptions = [{ value: "cot_valor_max", label: "Valor Máximo", span: 2 },{ value: "cot_valor_min", label: "Valor Mínimo", span: 2}];

const estadosOptions = [
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "SC", label: "Santa Catarina" },
   { value: "PR", label: "Paraná" },
   { value: "GO", label: "Goias" },
   { value: "MG", label: "Minas Gerais" },
];

export default function IntergraosTrigoAgranel() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // Aviso de cotação fora do padrão, como em soja e milho: compara o que é
  // digitado com o valor carregado (variação acima de 10%).
  const baselineRef = useRef({});
  const [camposComAlerta, setCamposComAlerta] = useState({});

  async function getData(value) {
    setIsLoading(true);
    const response = await request(
      `/trigo_agranel/getLastTrigoAgranelByUf?uf=${value}`,
      {
        method: "GET",
      }
    );
    const data = {
      ...response,
      endpoint: "updateTrigoAgranel",
      path: "trigo_agranel",
    };
    Object.keys(data).forEach((el, index) => {
      if (typeof data[el] === "number" && el !== "cot_id") {
        data[el] = data[el].toFixed(2);
        data[el] = data[el].replace(".", ",");
      }
    });
    setCotacoesData(data);
    baselineRef.current = data;
    setCamposComAlerta({});
    setIsLoading(false);
  }

  return (
    <Form>
      <Descriptions
        title={"Intergrãos - Trigo - Saca- 60kg"}
        bordered
        extra={
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            icon={<FaSave />}
            disabled={isLoading}
            onClick={() => {
              console.log(cotacoesData);
              updateData(cotacoesData);
            }}
          >
            Atualizar
          </Button>
        }
        style={{ padding: 10 }}
      >
        <Descriptions.Item
          label={"Estado"}
          span={3}
          children={
            <Select
              style={{ width: "100%", marginTop: "10px" }}
              onChange={(value) => {
                setCotacoesData({ ...cotacoesData, cot_uf: value });
                getData(value);
              }}
              placeholder="Selecione o estado"
            >
              {estadosOptions.map((el, index) => {
                return (
                  <Select.Option key={index} value={el.value}>
                    {el.label}
                  </Select.Option>
                );
              })}
            </Select>
          }
        />
        <Descriptions.Item
          label={"Última Alteração"}
          span={3}
          children={formatDateHourToBR(cotacoesData?.cot_data)}
        />
        {!isLoading &&
          trigoOptions.map((element) => (
            <Descriptions.Item
              label={element.label}
              span={element.span}
              children={
                element?.type === "checkbox" ? (
                  <Checkbox
                    checked={cotacoesData[element.value]}
                    onChange={(event) => {
                      const inputValue = event.target.checked;
                      const formattedValue = inputValue;
                      const newData = {
                        ...cotacoesData,
                        [element.value]: formattedValue,
                      };
                      setCotacoesData(newData);
                    }}
                  />
                ) : (
                  <Tooltip
                    title={camposComAlerta[element.value]?.mensagem}
                    open={!!camposComAlerta[element.value]}
                    color="orange"
                  >
                    <Input
                      status={camposComAlerta[element.value] ? "warning" : ""}
                      value={cotacoesData[element.value]}
                      onChange={(event) => {
                        const inputValue = event.target.value;
                        const formattedValue = inputValue.trim();
                        const newData = {
                          ...cotacoesData,
                          [element.value]: formattedValue,
                        };
                        setCotacoesData(newData);
                      }}
                      onBlur={() => {
                        const alerta = verificarVariacaoValor(
                          cotacoesData[element.value],
                          baselineRef.current[element.value],
                          element.label
                        );
                        setCamposComAlerta((prev) => ({
                          ...prev,
                          [element.value]: alerta,
                        }));
                      }}
                    />
                  </Tooltip>
                )
              }
            />
          ))}
      </Descriptions>
    </Form>
  );
}
